import { RootState } from "../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.consultationList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.consultationList.error;
export const consultationListDataResponse = (state: RootState) =>
  state.consultationList.consultationListResponse;
